import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { IAssignment } from "@/data/assignments";
import { Col, Row } from "@/eworkitComponents";
import { useFormats } from "@/hooks/Formats";
import { JobRequestDetailIconSection } from "@/views/JobRequests/Detail/components";

interface IAssignmentDigestProps {
  assignment: IAssignment;
}

export const AssignmentDigest: FC<IAssignmentDigestProps> = ({ assignment }) => {
  const { t } = useTranslation("session");
  const { formatCost } = useFormats();

  return (
    <Row>
      {!!assignment.legalEntityVatNo && (
        <Col width={{ xxs: 12, xs: 6, sm: 4, lg: 3 }}>
          <JobRequestDetailIconSection
            label={t("ASSIGNMENTS.DETAILS.VAT_NUMBER")}
            value={assignment.legalEntityVatNo}
            icon="vat"
          />
        </Col>
      )}

      {!!assignment.legalEntityName && (
        <Col width={{ xxs: 12, xs: 6, sm: 4, lg: 3 }}>
          <JobRequestDetailIconSection
            label={t("ASSIGNMENTS.DETAILS.LEGAL_ENTITY")}
            value={assignment.legalEntityName}
            icon="banking"
          />
        </Col>
      )}

      <Col width={{ xxs: 12, xs: 6, sm: 4, lg: 3 }}>
        <JobRequestDetailIconSection label={t("ASSIGNMENTS.DETAILS.ROLE")} value={assignment.role} icon="user_fill" />
      </Col>

      <Col width={{ xxs: 12, xs: 6, sm: 4, lg: 3 }}>
        <JobRequestDetailIconSection
          label={t("ASSIGNMENTS.DETAILS.SENIORITY")}
          value={assignment.level}
          icon="business-dev"
        />
      </Col>

      {!!assignment.totalEstimatedCost && (
        <Col width={{ xxs: 12, xs: 6, sm: 4, lg: 3 }}>
          <JobRequestDetailIconSection
            label={t("ASSIGNMENTS.DETAILS.ESTIMATED_TOTAL_EARNINGS")}
            value={formatCost(assignment.totalEstimatedCost, assignment.rateCurrency)}
            icon="cash_multiple"
            grow={0}
          />
        </Col>
      )}
    </Row>
  );
};
